import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import theme from './theme';
import AppRoutes from './components/Router';
import ErrorBoundary from './components/common/ErrorBoundary';
import MssToast from './components/common/MssToast';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import './scss/mss.main.scss';

// Called at module scope, not inside componentDidMount/useEffect:
// From MUI documentation: "You must call the setLicenseKey() function before React renders the first component in your app... Because the license is verified when the components mount, this function must be called in the browser."
// A lifecycle hook runs after the first render/mount, so a DataGridPro mounted on the initial page could fail its license check before the hook fires.
// https://mui.com/x/introduction/licensing/#installation
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ErrorBoundary>
        <AppRoutes />
        <MssToast />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
